import React, { useState } from 'react'
import axios from 'axios'
import Dropdown from 'react-bootstrap/Dropdown'
import { useNavigate } from 'react-router-dom'

const FindPlayer = () => {
  const [searchQuery, setSearchQuery] = useState('')
  const [searchResults, setSearchResults] = useState([])
  const navigate = useNavigate()

  const handleSearchChange = async event => {
    const query = event.target.value
    setSearchQuery(query)

    if (query.length > 3) {
      try {
        const loggedUser = window.localStorage.getItem('loggedUser')
        const token = loggedUser ? JSON.parse(loggedUser) : null
        const response = await axios.get(
          `/api/players/search?query=${encodeURIComponent(query)}`,
          { headers: { 'x-oauth-token': token } }
        )
        setSearchResults(response.data)
      } catch (error) {
        console.error('Error searching players', error)
        setSearchResults([])
      }
    } else {
      setSearchResults([])
    }
  }

  const handlePlayerSelect = player => {
    navigate(`/players/${player.playerId}`)
  }

  return (
    <div style={{ position: 'relative' }}>
      <input
        type="text"
        value={searchQuery}
        onChange={handleSearchChange}
        placeholder="Search by player ID or name"
        style={{ width: '100%', padding: '0.5rem', marginBottom: '0.5rem' }}
      />
      {searchResults.length > 0 && (
        <Dropdown>
          <Dropdown.Menu show>
            {searchResults.map(player => (
              <Dropdown.Item
                key={player.playerId}
                onClick={() => handlePlayerSelect(player)}
              >
                {player.firstName} {player.lastName} ({player.playerId})
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      )}
    </div>
  )
}

export default FindPlayer
